import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

import { MatIconModule } from '@angular/material/icon';

const DEFAULT_SPINNER_SIZE = 24;

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
  host: {
    '[style.--spinner-size]': 'sizePx()',
  },
})
export class LoadingSpinnerComponent {
  readonly size = input(DEFAULT_SPINNER_SIZE);

  protected readonly sizePx = computed(() => `${this.size()}px`);
}
